// react-vis-timeline is CommonJS with an `__esModule`-style `default` export, which not every
// module loader unwraps (the dev-server dependency optimizer serves the raw exports object). Bare
// imports of the package are aliased here; the deep import below bypasses that alias...
import TimelineModule from "react-vis-timeline/build/index.js";

const unwrapped: unknown = (TimelineModule as { default?: unknown })?.default ?? TimelineModule;

export default unwrapped as typeof import("react-vis-timeline").default;
